/**
 * かんたん画面（らくらくフォン風）。
 *
 * 船員アプリは機能が増えて画面の情報量が多くなったため、
 * 「1画面1操作・大きな文字・大きなボタン・使わないものは出さない」表示に切り替えられるようにする。
 * 端末ごとの設定（localStorage）で、記録や他の人の画面には影響しない。
 */
const KEY = 'catms_simple_mode';

export function isSimpleMode(): boolean {
  return localStorage.getItem(KEY) === '1';
}

export function setSimpleMode(on: boolean): void {
  if (on) localStorage.setItem(KEY, '1');
  else localStorage.removeItem(KEY);
}
